<div class="dv-page">

  <div class="dv-empty" *ngIf="!_isSuperAdmin && !loading">
    Only a super-admin or a driver manager can manage driver accounts.
  </div>

  <ng-container *ngIf="_isSuperAdmin">
    <div class="dv-error" *ngIf="error">{{ error }}</div>

    <!-- Same tab bar as Company Sites: start-aligned, theme background, no animation. -->
    <mat-tab-group [(selectedIndex)]="selectedTab" class="tab-group navbar1" mat-align-tabs="start"
      backgroundColor="theme" animationDuration="0ms">
      <mat-tab label="Drivers">
        <app-table-standard-layout [dataSource$]="drivers$" [title]="'Drivers — ' + currentCompanyName()"
          [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton"
          [columnSettings]="columnSettings" [forceLoading]="loading"
          [searchFields]="['name','email','employer','phone']">
        </app-table-standard-layout>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          Not in a company<span class="dv-badge" *ngIf="unassignedCount">{{ unassignedCount }}</span>
        </ng-template>
        <p class="dv-tab-note">
          These users have the Driver role but are not in any company yet, so they are not on any
          company's driver list. Add them to {{ currentCompanyName() }} with the + button.
        </p>
        <app-table-standard-layout [dataSource$]="unassigned$" [title]="'Drivers not in any company'"
          [rowActionButtons]="unassignedActionButtons" [showExport]="false"
          [columnSettings]="unassignedColumns" [forceLoading]="loading"
          [searchFields]="['name','email']">
        </app-table-standard-layout>
      </mat-tab>

      <mat-tab label="Settings">
        <div class="dv-settings">
          <h4>Phone numbers in the driver app</h4>
          <p class="text-muted">
            Shown under the menu in the driver app as tap-to-call, for all drivers.
            They work without mobile signal.
          </p>
          <div class="dv-empty" *ngIf="!supportLoaded">Loading…</div>
          <ng-container *ngIf="supportLoaded">
            <div class="dv-form-row">
              <mat-form-field appearance="outline" class="dv-field">
                <mat-label>Support</mat-label>
                <input matInput [(ngModel)]="support.supportPhone" placeholder="+47 …" autocomplete="off">
              </mat-form-field>
              <mat-form-field appearance="outline" class="dv-field">
                <mat-label>Road assistance</mat-label>
                <input matInput [(ngModel)]="support.roadAssistPhone" placeholder="+47 …" autocomplete="off">
              </mat-form-field>
            </div>
            <div class="dv-form-row" *ngFor="let c of support.extraContacts; let i = index">
              <mat-form-field appearance="outline" class="dv-field">
                <mat-label>Label</mat-label>
                <input matInput [(ngModel)]="c.label" placeholder="e.g. Depot Oslo" autocomplete="off">
              </mat-form-field>
              <mat-form-field appearance="outline" class="dv-field">
                <mat-label>Phone</mat-label>
                <input matInput [(ngModel)]="c.phone" placeholder="+47 …" autocomplete="off">
              </mat-form-field>
              <button mat-icon-button (click)="removeContact(i)" matTooltip="Remove">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="dv-form-actions">
              <button mat-stroked-button (click)="addContact()" [disabled]="support.extraContacts.length >= 6">
                <mat-icon>add</mat-icon> Another number
              </button>
              <button mat-flat-button color="primary" (click)="saveSupport()" [disabled]="supportSaving">
                {{ supportSaving ? 'Saving…' : 'Save' }}
              </button>
            </div>
          </ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
